import { useRef, useEffect } from 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../../../hooks/useDocumentsAppConfigs.js";
import { observer } from 'mobx-react';
import _css from '@emotion/css';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";

var FillableCheckboxField = function FillableCheckboxField(_ref) {
  var selected = _ref.selected,
      field = _ref.field,
      disabled = _ref.disabled,
      onFocus = _ref.onFocus,
      reassigningFieldsEnabled = _ref.reassigningFieldsEnabled;
  var data = field.data;
  var checked = !!data.value;
  var bounding = useRef(null);

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  var highlightUnassignedFields = pdfStore.highlightUnassignedFields;
  var isAssignedToCurrentUser = field.belongsTo(currentUserId, currentUserPermissions);
  var isUnassignedField = !data.parties.length;
  disabled = disabled || pdfStore.signableOnly;
  var bgColor = 'bg-transparent';
  var borderColor = '';

  if (!disabled) {
    if (highlightUnassignedFields) {
      bgColor = isAssignedToCurrentUser ? 'bg-primary' : 'bg-info';

      if (isAssignedToCurrentUser) {
        borderColor = 'border-primary';
      } else if (isUnassignedField) {
        borderColor = 'border-warning';
      } else {
        borderColor = 'border-info';
      }
    } else {
      bgColor = isAssignedToCurrentUser ? 'bg-primary' : 'bg-transparent';
      borderColor = isAssignedToCurrentUser ? 'border-primary' : '';
    }
  }

  var fillable = !disabled && isAssignedToCurrentUser;
  useEffect(function () {
    if (selected) {
      bounding.current.focus();
    }
  }, [selected]);

  var toggleChecked = function toggleChecked() {
    if (fillable) {
      field.updateData({
        value: !checked
      });
    }
  };

  var handleFocus = function handleFocus(e) {
    if (fillable || reassigningFieldsEnabled) {
      onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }
  };

  return jsx("g", null, jsx("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    className: "".concat(bgColor, " ").concat(selected || isUnassignedField ? borderColor : ''),
    fillOpacity: bgColor === 'bg-info' ? 0.75 : 0.25
  }), jsx("foreignObject", {
    x: x,
    y: y,
    width: width,
    height: height
  }, jsx("div", {
    tabIndex: 0,
    role: "checkbox",
    ref: bounding,
    className: classnames(['form-control', 'shadow-none', 'bg-transparent', 'border-0', 'd-flex align-items-center justify-content-center']),
    style: {
      width: width,
      height: height,
      padding: 1
    },
    onMouseDown: toggleChecked,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ') {
        // space key
        e.preventDefault();
        toggleChecked();
      }
    },
    onFocus: handleFocus,
    "data-testid": "checkbox",
    css:
    /*#__PURE__*/
    _css({
      cursor: fillable || reassigningFieldsEnabled ? 'pointer' : ''
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    "aria-checked": checked
  }, checked && jsx("div", {
    className: "bg-dark h-100 w-100",
    "data-testid": "checked-square"
  }))));
};

FillableCheckboxField.displayName = "FillableCheckboxField";
var FillableCheckboxField$1 = observer(FillableCheckboxField);
export default FillableCheckboxField$1;